import { Link } from "react-router-dom";

const NotFound = () => (
  <div className="container-page py-32 text-center" data-testid="notfound-page">
    <div className="overline mb-4">404</div>
    <h1 className="font-serif text-5xl">Page not found</h1>
    <p className="mt-4 text-muted-foreground">The page you were looking for has moved or never existed.</p>
    <Link to="/" className="btn-primary mt-8 inline-flex" data-testid="nf-home-btn">Return home</Link>
  </div>
);

export default NotFound;
